export const ALERT_DEFAULT = { open: false, message: '', type: 'info' }
export const USER_STATUS = {
  INVALID_SESSION: 'INVALID_SESSION',
  LOST_CONNECTION: 'DISCONNECTED_SESSION',
  DUPLICATED_SESSION: 'DUPLICATE_SESSION',
  EXPULSED: 'EXPULSED',
}
export const LOT_STATUS = {
  PENDIENTE: 0,
  ACTUAL: 1,
  SIN_POSTOR: 2,
  VENDIDO: 3,
  RETIRADO: 4
}
export const AUCTION_STATUS = {
  INICIO: 1,
  PRESENTACION: 2,
  OFERTAS: 3,
  CIERRE: 4,
  ADJUDICACION: 5,
  FIN: 6,
}
export const AUCTION_TYPE = {
  REMATE_BIENES: 1,
  LICITACION_BIENES: 3,
  REMATE_LICITACION_BIENES: 5,
  REMATE_PROPIEDADES: 2,
  LICITACION_PROPIEDADES: 4,


}
export const USER_ROLE = {
  ADMIN: 1,
  AUCTIONEER: 2,
  LOBBY: 3,
  MODERATOR: 4,
  USER: 5,
  GUEST: 6,
  BLOCKED: 7,
}

export const AUCTION_AREA = {
  1: 'BIENES',
  2: 'PROPIEDADES',
  BIENES: 1,
  PROPIEDADES: 2,
};

// Marcas de garantía: mismos ids que la tabla de marcas del web-site.
export const GUARANTEE_MARK_TYPE = {
  NO_CONSTITUIDA: 1,
  CLIENTE: 2,
  MANDANTE: 3,
  INTERNO: 4,
  OBSERVADOR: 5,
};
export const GUARANTEE_MARK_LABEL = {
  [GUARANTEE_MARK_TYPE.NO_CONSTITUIDA]: 'No constituida',
  [GUARANTEE_MARK_TYPE.CLIENTE]: 'Cliente',
  [GUARANTEE_MARK_TYPE.MANDANTE]: 'Mandante',
  [GUARANTEE_MARK_TYPE.INTERNO]: 'Interno',
  [GUARANTEE_MARK_TYPE.OBSERVADOR]: 'Observador',
};
export const ACTIONS = {
  ADMINISTRATOR_MODULE: {
    VIEW_ADMINISTRATOR_MODULE: 'VIEW_ADMINISTRATOR_MODULE',
  },
  AUCTIONEER_MODULE: {
    VIEW_AUCTIONEER_MODULE: 'VIEW_AUCTIONEER_MODULE',
  },
  USER_CONTROL_MODULE: {
    VIEW_USER_CONTROL_MODULE: 'VIEW_USER_CONTROL_MODULE',
  },
  ROOM_OFFER_MODULE: {
    VIEW_ROOM_OFFER_MODULE: 'VIEW_ROOM_OFFER_MODULE',
  },
  ROOM_MODULE: {
    VIEW_ROOM_MODULE: 'VIEW_ROOM_MODULE',
  },
  ROBIN_HOOD_MODULE: {
    VIEW_ROBIN_HOOD_MODULE: 'VIEW_ROBIN_HOOD_MODULE',
  },
  USER_ENTRY_MODULE: {
    USER_ENTRY_MODULE: 'USER_ENTRY_MODULE',
  },
  CLIENT_MODULE: {
    VIEW_CLIENT_MODULE: 'VIEW_CLIENT_MODULE',
    VIEW_OFFER_BUTTON: 'VIEW_OFFER_BUTTON',
    VIEW_AUCTION_POLL: 'VIEW_AUCTION_POLL',

  },
  GUEST_SWITCH: {
    VIEW_GUEST_SWITCH: 'VIEW_GUEST_SWITCH',
  },


}
// externalId del único usuario habilitado para ver la herramienta de
// auditoría de adjudicaciones (compara lo adjudicado en el remate vs. lo
// oficializado en la web). No es un rol: es este usuario puntual.
export const ADJUDICATION_AUDIT_USER_ID = 14546

export const ROLE = {
  SUPERADMIN: 'SUPERADMIN',
  CLIENT: 'CLIENT',
  GUEST: 'GUEST',
  GOODS: {
    ADMIN: 'GOODS_ADMIN',
    OPERATIONS: 'GOODS_OPERATIONS',
    FINANCE: 'GOODS_FINANCE',
    COMMERCIAL: 'GOODS_COMMERCIAL',
    DIRECT_SALE: 'GOODS_DIRECT_SALE',
  },
  PROPS: {
    ADMIN: 'PROPS_ADMIN',
    OPERATIONS: 'PROPS_OPERATIONS',
    FINANCE: 'PROPS_FINANCE',
    COMMERCIAL: 'PROPS_COMMERCIAL',
    DIRECT_SALE: 'PROPS_DIRECT_SALE',
  },
}

// Breakpoints por defecto de Material UI
// xs: 0px      -> hasta 600px
// sm: 600px    -> hasta 900px
// md: 900px    -> hasta 1200px
// lg: 1200px   -> hasta 1536px
// xl: 1536px+  -> en adelante

// const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
// const isMedium = useMediaQuery(theme.breakpoints.between('sm', 'md'))
// const isLarge = useMediaQuery(theme.breakpoints.down('lg'))
